 /* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "@material-ui/styles";
import Button from "@material-ui/core/Button";

import theme from "../../../../Themes/defaultTheme";
import { makeStyles } from "@material-ui/core/styles";
import ProductLogoSvg from "../../../Molecules/Common/Navigations/ProductLogoSvg";

const useStyles = makeStyles((theme) => ({
  premiumPrimary: {
    textTransform: "none",
    fontWeight: 700,
    borderRadius: "calc(12px * var(--app-radius-scale, 1))",
    minHeight: 34,
    padding: "0 18px",
    backgroundColor: "var(--color-primary-main)",
    color: "var(--color-primary-contrast)",
    border: "1px solid var(--color-primary-main)",
    boxShadow: "0 8px 16px rgba(15, 23, 42, 0.16)",
    transition: "background 0.25s ease, transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease",
    "&:hover": {
      backgroundColor: "var(--color-primary-main)",
      filter: "brightness(1.1)",
    },
    "&.Mui-disabled": {
      background: "var(--total_row_boldbackground) !important",
      color: "var(--color-text-secondary) !important",
      borderColor: "var(--total_row_boldbackground) !important",
      boxShadow: "none !important",
      transform: "none !important",
      opacity: 0.6,
    },
  },
  premiumSecondary: {
    textTransform: "none",
    fontWeight: 700,
    borderRadius: "calc(12px * var(--app-radius-scale, 1))",
    minHeight: 34,
    backgroundColor: "var(--color-background-paper)",
    color: "var(--color-primary-text)",
    border: "1px solid var(--total_row_boldbackground)",
    boxShadow: "none",
    transition: "background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease, filter 0.2s ease",
    "&:hover": {
      backgroundColor: "var(--color-background-default)",
      borderColor: "var(--color-primary-main)",
      filter: "brightness(0.95)",
      transform: "translateY(-1px)",
    },
    "&.Mui-disabled": {
      backgroundColor: "var(--total_row_boldbackground) !important",
      color: "var(--color-text-secondary) !important",
      borderColor: "var(--total_row_boldbackground) !important",
      transform: "none !important",
      boxShadow: "none !important",
      opacity: 0.6,
    },
  },
  premiumGhost: {
    textTransform: "none",
    fontWeight: 600,
    color: "var(--color-text-secondary)",
    borderRadius: "calc(8px * var(--app-radius-scale, 1))",
    "&:hover": {
      backgroundColor: "rgba(128, 128, 128, 0.1)",
      color: "var(--color-text-primary)",
    },
  },
  premiumProduct: {
    textTransform: "none",
    fontWeight: 700,
    borderRadius: "calc(12px * var(--app-radius-scale, 1))",
    minHeight: 36,
    padding: "0 18px",
    letterSpacing: "0.02em",
    background:
      "linear-gradient(135deg, var(--sidebar-background) 0%, var(--color-primary-main) 100%)",
    color: "var(--color-primary-contrast)",
    border: "1px solid var(--color-primary-main)",
    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.18)",
    transition:
      "background 0.25s ease, transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease",
    "& .MuiButton-startIcon": {
      marginRight: 10,
    },
    "& .productLogoIcon": {
      color: "var(--color-primary-contrast)",
      flexShrink: 0,
      filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.18))",
    },
    "&:hover": {
      boxShadow: "0 12px 24px rgba(15, 23, 42, 0.26)",
      transform: "translateY(-1px)",
      filter: "brightness(1.08)",
    },
    "&:active": {
      transform: "translateY(0)",
      filter: "brightness(0.96)",
    },
    "&.Mui-disabled": {
      background: "var(--total_row_boldbackground) !important",
      color: "var(--color-text-secondary) !important",
      borderColor: "var(--total_row_boldbackground) !important",
      boxShadow: "none !important",
      transform: "none !important",
      opacity: 0.6,
      "& .productLogoIcon": {
        color: "var(--color-text-secondary) !important",
        filter: "none !important",
      },
    },
  },
}));
const A_Button = (props) => {
  const classes = useStyles();

  const getPremiumClass = () => {
    switch (props.premiumVariant) {
      case "primary": return classes.premiumPrimary;
      case "secondary": return classes.premiumSecondary;
      case "ghost": return classes.premiumGhost;
      case "product": return classes.premiumProduct;
      default: return "";
    }
  };

  const isProduct = props.premiumVariant === "product";
  const productEndIcon = isProduct ? (
    <ProductLogoSvg
      size={props.productLogoSize || 15}
      className="productLogoIcon"
      title={props.label}
    />
  ) : null;

  return (
    <ThemeProvider theme={theme}>
      <Button
        //properties
        style={props.style}
        variant={props.variant}
        color={props.color}
        size={props.size}
        disabled={props.disabled}
        startIcon={props.startIcon}
        endIcon={props.endIcon || productEndIcon}
        className={`${getPremiumClass()} ${props.className || ""}`}
        //events
        onClick={props.onClick}
        onDoubleClick={props.onDoubleClick}
        href={props.href}
        target={props.target}
      >
        {props.label}
      </Button>
    </ThemeProvider>
  );
};
A_Button.defaultProps = {
  label: "Button",
  variant: "contained",
  color: "default",
  size: "medium",
  disabled: false,
  style:{textTransform: "none"}
};
A_Button.propTypes = {
  variant: PropTypes.oneOf(["text", "contained", "outlined"]),
  color: PropTypes.oneOf(["default", "inherit", "primary", "secondary","white"]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  startIcon: PropTypes.element,
  endIcon: PropTypes.element,
  premiumVariant: PropTypes.oneOf(["primary", "secondary", "ghost", "product"]),
  productLogoSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
};
export default A_Button;
